import React, { Component } from 'react';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import { localize } from 'react-localize-redux';

class OptionsDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  UNSAFE_componentWillReceiveProps({ allowedOpen }) {
    if (allowedOpen !== undefined) {
      const currentOpenState = this.state.open;
      this.setState({ open: allowedOpen && currentOpenState });
    }
  }

  handleTouchTap = event => {
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { translate } = this.props;
    return (
      <div>
        <button
          type="button"
          className="link-button"
          onClick={this.handleTouchTap}
          style={{ cursor: 'pointer' }}
        >
          {this.props.label || translate('landlordPortal.optionsDropdown.options')}
        </button>

        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>{this.props.children}</Menu>
        </Popover>
      </div>
    );
  }
}

export default localize()(OptionsDropdown);
